import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";
import { XIcon } from "@Console/integrations/notazz/assets/icons/XIcon";

import { ConsolePageModalHeaderContainer } from "./styles";

interface IConsolePageModalHeaderProps {
  children?: React.ReactNode;
  handleCloseModal: VoidFunction;
}

export const ConsolePageModalHeader = ({
  children,
  handleCloseModal,
}: IConsolePageModalHeaderProps) => {
  return (
    <ConsolePageModalHeaderContainer>
      {children}

      <ConsolePageForm.Button
        id="close-modal-button"
        variant="transparent"
        onClick={handleCloseModal}
      >
        <XIcon />
      </ConsolePageForm.Button>
    </ConsolePageModalHeaderContainer>
  );
};
